import React, { Component } from 'react';
import { Layout, Image, Typography } from 'antd';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './Games.css'

const Content = Layout;
const {Title} = Typography


class Games extends Component {
  constructor(props) {
    super(props)
    this.state = {
      games : [],
      trigger : true
    }
  }

  componentDidMount() {
    if(this.state.trigger) {
      const getGames = async () => {
        const result = await axios.get("https://backendexample.sanbersy.com/api/data-game")
        this.setState({
          games: [...result.data]
        })
        this.setState({
          trigger: false
        })
      }
      getGames()
    }
  }

  render() {
    const games = this.state.games
    return (
      <Content className="site-layout" style={{ padding: '0 50px', marginTop: 64 }}>
        <div id="games-page">
          <Title level={2}>
            Games
          </Title>
          <div className="games">
            {
              games.map((el) => 
                <div className="game">
                  <Image
                    src={el.image_url}
                    preview={false}
                    height={"20em"}
                    width={"15em"}
                  />
                  <Link to={`detail/game/${el.id}`} >
                    <h3 className="game-title">{el.name}</h3>
                  </Link>
                </div>
              )
            }
          </div>
        </div>
      </Content>
    )
  }
}

export default Games